// extracted by mini-css-extract-plugin
export default {"root":"OYPfP1uFCUQiTIzEuInK","plus":"qIiHUFgYEJuQgakYNG1H","label":"t_cxk1C0EeQ7R6zsMOr6"};